module.exports = __webpack_public_path__ + "img/product-banner_1.c8087781.png";